(function () {
 
  const INFO_MAP = {
    'Couches - Taille 1': { weight: 'de 2 à 5 kg',  qty: '28 couches' },
    'Couches - Taille 2': { weight: 'de 2 à 6 kg',  qty: '28 couches' },
    'Couches - Taille 3': { weight: 'de 3 à 6 kg',  qty: '52 couches' },
    'Couches - Taille 4': { weight: 'de 4 à 9 kg',  qty: '44 couches' },
    'Couches - Taille 5': { weight: 'de 11 à 25 kg', qty: '40 couches' },
  };

  function normalizeTitle(str) {
    return (str || '').replace(/\s+/g, ' ').trim();
  }

  function ensureInfosContainer(heading) {
    let container = heading.nextElementSibling;

    if (!(container && container.classList?.contains('item-infos'))) {
      container = document.createElement('div');
      container.className = 'item-infos';
      container.style.display = 'flex';
      container.style.flexDirection = 'column';
      container.style.gap = '4px';

      heading.insertAdjacentElement('afterend', container);
    }

    return container;
  }

  function ensureP(container, className) {
    let p = container.querySelector(`p.${className}`);
    if (!p) {
      p = document.createElement('p');
      p.className = className;
      p.style.margin = '0';
      container.appendChild(p);
    }
    return p;
  }

  function injectInfos() {
    const headings = document.querySelectorAll(
      'span[role="heading"][aria-level="3"]'
    );

    headings.forEach((heading) => {
      const title = normalizeTitle(heading.textContent);
      const info = INFO_MAP[title];
      if (!info) return;

      const container = ensureInfosContainer(heading);

      const pWeight = ensureP(container, 'weight');
      if (pWeight.textContent !== info.weight) {
        pWeight.textContent = info.weight;
      }

      const pQty = ensureP(container, 'qty');
      if (pQty.textContent !== info.qty) {
        pQty.textContent = info.qty;
      }
    });
  }


  injectInfos();

  
  let raf = null;
  const observer = new MutationObserver(() => {
    if (raf) return;
    raf = requestAnimationFrame(() => {
      raf = null;
      injectInfos();
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();

(function initRechargeFrequencyButtons() {
  const ROOT_SELECTOR = '#bundling-app';
  const REGION_SELECTOR = '[role="region"][aria-label="Abonnement - Bundle couches"]';
  const WRAP_ID = 'custom-frequency-buttons';
  const NEW_TITLE_TEXT = 'Fréquence de livraison';

  const $ = (sel, root = document) => root.querySelector(sel);
  const $all = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function getRoot() {
    return $(ROOT_SELECTOR);
  }

  function getRegion(root) {
    return $(REGION_SELECTOR, root);
  }

 
  function replaceRechargeTitle(root) {
    const headings = $all(
      'span[role="heading"][aria-level="1"].recharge-heading-h1',
      root
    );

    headings.forEach((el) => {
      if (el.textContent.trim() !== NEW_TITLE_TEXT) {
        el.textContent = NEW_TITLE_TEXT;
      }
    });
  }

  function getHiddenSelects(root) {
    return $all('[data-testid="hidden-select-container"] select', root).filter(
      (s) => s && s.options && s.options.length
    );
  }

  function getFrequencyOptions(selectEl) {
    return Array.from(selectEl.options)
      .filter((o) => String(o.value || '').trim() !== '')
      .map((o) => ({
        value: o.value,
        label: (o.textContent || '').trim(),
      }));
  }

  function setSelectValue(selectEl, value) {
    if (!selectEl) return false;
    if (selectEl.value === value) return true;

    selectEl.value = value;
    selectEl.dispatchEvent(new Event('input', { bubbles: true }));
    selectEl.dispatchEvent(new Event('change', { bubbles: true }));

    return true;
  }

  function setFrequencyOnAllSelects(root, value) {
    const selects = getHiddenSelects(root);
    let ok = false;
    selects.forEach((sel) => {
      ok = setSelectValue(sel, value) || ok;
    });
    return ok;
  }

  function setActive(container, value) {
    container.querySelectorAll('.freq-btn').forEach((b) => {
      b.classList.toggle('is-active', b.getAttribute('data-value') === value);
    });
  }

  function renderButtons(root, region) {
    if ($(`#${WRAP_ID}`, root)) return;

    const selects = getHiddenSelects(root);
    if (!selects.length) return;

    const options = getFrequencyOptions(selects[0]);
    if (!options.length) return;

    const wrap = document.createElement('div');
    wrap.id = WRAP_ID;
    wrap.setAttribute('data-custom', 'frequency-buttons');

   
    const title = document.createElement('div');
    title.className = 'freq-title';
    title.textContent = NEW_TITLE_TEXT;
    wrap.appendChild(title);

   
    const buttonsContainer = document.createElement('div');
    buttonsContainer.className = 'freq-buttons';

    const currentValue = selects.find((s) => s.value)?.value || null;

    options.forEach((opt) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'freq-btn';
      btn.textContent = opt.label;
      btn.setAttribute('data-value', opt.value);

      btn.addEventListener('click', () => {
        const ok = setFrequencyOnAllSelects(root, opt.value);
        if (ok) setActive(buttonsContainer, opt.value);
      });

      buttonsContainer.appendChild(btn);
    });

    wrap.appendChild(buttonsContainer);

    if (currentValue) setActive(buttonsContainer, currentValue);

    region.parentNode.insertBefore(wrap, region);
  }

  function tryInit() {
    const root = getRoot();
    if (!root) return;

    replaceRechargeTitle(root);

    const region = getRegion(root);
    if (!region) return;

    renderButtons(root, region);
  }

 
  tryInit();

  
  const root = getRoot();
  if (!root) return;

  const mo = new MutationObserver(() => {
    tryInit();
  });

  mo.observe(root, { childList: true, subtree: true });
})();



